<template>
	<div>
		<downloadcommon ref="download"></downloadcommon>
		<!-- 导入弹窗 -->
		<el-dialog :visible.sync="daorudiag" width="700px" :close-on-click-modal="false" append-to-body v-dialogDrag>
			<minhead :headtitle="daorutitle" :isdiag="true"></minhead>
			<div class="Verticalcenter">
				<div class="Centerhorizontally" style="margin-left: 50px;">
					<el-input style="width: 300px;margin-right: 16px;" disabled v-model="upfilename"></el-input>
					<label style="display: flex;align-items: center;">
						<div class="Centerhorizontally bt1">选择文件</div>
						<input type="file" class="sendinput" @change="uploadFile($event)"
							accept="application/vnd.ms-excel ,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain,text/xml "
							:value="filestate" />
					</label>
				</div>
			</div>
			<div class="buttomanniu">
				<el-button plain type="primary" @click="sureupload">确定</el-button>
				<el-button @click="daorudiag = false">关闭</el-button>
			</div>
		</el-dialog>
		<Billingcomponent :outerVisible="outerVisible" @closeouterVisible="closeouterVisible"
			:ruleFormb="allitem.ruleFormb" :priceall="allitem.priceall" :totalall="allitem.totalall"
			:ruleFormbxiao="allitem.ruleFormbxiao" :form_chae="allitem.form_chae" :bztext="allitem.bztext"
			:stateall="allitem.stateall" :listoflists="allitem.listoflists" :invoiceNo="allitem.invoiceNo"
			:invoiceCode="allitem.invoiceCode" :billingDate="allitem.billingDate" title="预览发票"
			:documentStatus="allitem.documentStatus" :checkCode="allitem.checkCode"></Billingcomponent>

		<el-form :model="searchalllist" ref="form" label-width="100px" style="margin-top: 16px;margin-right: 16px;">
			<div :class="isshou?'minheight':'maxheight'">
				<div class="between-line">
					<el-form-item label="发票种类:" style="width: 25%;">
						<el-select v-model="searchalllist.faplxdm">
							<el-option label="全部" value></el-option>
							<el-option label="纸质普票" value="007"></el-option>
							<el-option label="纸质专票" value="004"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发票号码:" style="width: 25%;">
						<el-input v-model="searchalllist.faphm"></el-input>
					</el-form-item>
					<el-form-item style="width: 50%;">
						<div class="Centerupdown ">
							<el-button type="primary" plain @click="forshuai" style="z-index:2;width: 100px;">查询
							</el-button>
							<el-button @click="resetForm()">重置
							</el-button>
							<el-button plain @click="changeshou">更多条件<i class="el-icon-arrow-up el-icon--right"
									v-if="isshou"></i>
								<i class="el-icon-arrow-down el-icon--right" v-if="!isshou"></i>
							</el-button>
						</div>
					</el-form-item>
				</div>
				<div class="between-line">
					<el-form-item label="发票代码:" style="width: 25%;">
						<el-input v-model="searchalllist.fapdm"></el-input>
					</el-form-item>
					<el-form-item label="开票日期" style="width: 50%;">
						<el-date-picker v-model="searchalllist.kaiprq" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
					<el-form-item label="单据号:" style="width: 25%;">
						<el-input v-model="searchalllist.danjh"></el-input>
					</el-form-item>
				</div>
				<div class="between-line">
					<el-form-item label="未税金额:" style="width: 25%;">
						<el-input v-model="searchalllist.hejje"></el-input>
					</el-form-item>
					<el-form-item label="税额:" style="width: 25%;">
						<el-input v-model="searchalllist.hejse"></el-input>
					</el-form-item>
					<el-form-item label="购方名称:" style="width: 25%;">
						<el-input v-model="searchalllist.goufmc"></el-input>
					</el-form-item>
					<el-form-item label="购方识别号" style="width: 25%;">
						<el-input v-model="searchalllist.goufsbh"></el-input>
					</el-form-item>
				</div>
                <div class="between-line">
					<el-form-item label="销方名称" style="width: 25%;">
						<el-input v-model="searchalllist.xiaofmc"></el-input>
					</el-form-item>
					<el-form-item label="销方识别号" style="width: 25%;">
						<el-input v-model="searchalllist.xiaofsbh"></el-input>
					</el-form-item>
                    <el-form-item label="" style="width: 25%;visibility: hidden;"></el-form-item>
                    <el-form-item label="" style="width: 25%;visibility: hidden;"></el-form-item>
				</div>
			</div>
		</el-form>
		<div class="shousuo">
		</div>
		<div class="areacontent">
			<div class="between-line" style="padding-top: 25px;box-sizing: border-box;">
				<div class="Centerupdown">
					<el-button type="primary" @click.native="excelExport" plain>导出</el-button>
                    <el-button type="primary" @click.native="handleImport()" plain>导入</el-button>
				</div>
				<tabletag name="InvoiceQuerytab" :titledata="['单据号','单据状态','发票来源','发票类型','发票代码','发票号码','购方名称','购方识别号','未税金额'
				,'税额','开票日期','打印状态','是否清单','是否负数','原发票代码','原发票号码','制单人','申请人','参考一','参考二','税盘编号'
                ,'快递单号','快递下单日期','快递公司','销方名称','销方识别号']"
					@choosetitle="choosetitle"></tabletag>
			</div>
		</div>
		<div class="areatable" style="margin-left: 20px;">
			<div class="tableh">
				<el-table :data="tableData" border style="width: 100%" ref="multipleTable"
					@selection-change="handleSelectionChange" @sort-change="sortChange">
					<el-table-column type="selection" width="55" align="center"></el-table-column>
					<el-table-column prop="danjh" label="单据号" align="center" width="200" key="0"
						v-if="chooseheadlist.includes('单据号')"></el-table-column>
					<el-table-column prop="fapzt" label="单据状态" align="center" width="120" key="1"
						v-if="chooseheadlist.includes('单据状态')">
						<template slot-scope="scope">
							<!-- 发票状态 -1:草稿 0：入库保存；1：已审核；2：待开票；3：开票中；4：已开票；7：开票失败；8：暂不开票；9：已退票；34：无需开票 -->
							<p v-for="item in fapztlist" v-if="item.value==scope.row.fapzt" :style="item.style">
								<span>{{item.label}}</span>
								<el-tooltip class="item" effect="light" :content="scope.row.stateall.shibxx"
									v-if="scope.row.fapzt == '7'" placement="bottom">
									<img src="../../../assets/img/erroricon.svg" style="margin-left: 5px;" />
								</el-tooltip>
							</p>
						</template>
					</el-table-column>
					<el-table-column prop="faply" label="发票来源" width="100" align="center" key="2"
						v-if="chooseheadlist.includes('发票来源')">
						<template slot-scope="scope">
			 			<!-- 发票来源 发票来源 1：文件导入；2：手工录入；3：API接口 4:税控同步5:支付开票6:扫码开票 -->
							<p v-for="item in faplylist " v-if="item.value==scope.row.faply">{{item.label}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="faplxdm" label="发票类型" align="center" width="120" sortable="custom" key="3"
						v-if="chooseheadlist.includes('发票类型')">
						<template slot-scope="scope">
							<p v-for="item in fplxlist" v-if="item.value==scope.row.faplxdm" :style="item.style">
								<span>{{item.label}}</span>
							</p>
						</template>
					</el-table-column>
					<el-table-column prop="fapdm" label="发票代码" align="center" width="120" key="4" sortable="custom"
						v-if="chooseheadlist.includes('发票代码')">
					</el-table-column>
					<el-table-column prop="faphm" label="发票号码" align="center" width="120" sortable="custom" key="5"
						v-if="chooseheadlist.includes('发票号码')">
						<!-- <template slot-scope="scope">
							<el-button type="text" size="small" @click="handleClick(scope.$index,'预览发票')">
								{{ scope.row.faphm }}
							</el-button>
						</template> -->
					</el-table-column>
                   <el-table-column prop="kdpch" label="快递单号" align="center" width="180" key="6"
						v-if="chooseheadlist.includes('快递单号')"></el-table-column>
                    <el-table-column prop="kdxdrq" label="快递下单日期" align="center" width="200px" key="7"
						v-if="chooseheadlist.includes('快递下单日期')">
						<template slot-scope="scope">
							<div class="Centerhorizontally">{{ stringtostmp(scope.row.kdxdrq) }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="cank5" label="快递公司" align="center" width="180" key="16"
						v-if="chooseheadlist.includes('快递公司')"></el-table-column>
					<el-table-column prop="goufmc" label="购方名称" align="center" width="200" key="8"
						v-if="chooseheadlist.includes('购方名称')"></el-table-column>
                    <el-table-column prop="goufsbh" label="购方识别号" align="center" width="160" key="9"
						v-if="chooseheadlist.includes('购方识别号')"></el-table-column>
					<el-table-column prop="hejje" label="未税金额" align="center" width="150" key="10"
						v-if="chooseheadlist.includes('未税金额')"></el-table-column>
					<el-table-column prop="hejse" label="税额" align="center" width="150" key="11"
						v-if="chooseheadlist.includes('税额')"></el-table-column>
					<el-table-column prop="jiashj" label="价税合计" align="center" width="150" key="12"></el-table-column>
					<el-table-column prop="kaiprq" label="开票日期" align="center" width="200px" key="13"
						v-if="chooseheadlist.includes('开票日期')">
						<template slot-scope="scope">
							<div class="Centerhorizontally">{{ stringtostmp(scope.row.kaiprq) }}</div>
						</template>
					</el-table-column>
                    <el-table-column prop="xiaofmc" label="销方名称" align="center" width="200" key="14"
						v-if="chooseheadlist.includes('销方名称')"></el-table-column>
                    <el-table-column prop="xiaofsbh" label="销方识别号" align="center" width="160" key="15"
						v-if="chooseheadlist.includes('销方识别号')"></el-table-column>
					<!-- <el-table-column prop="dayzt" label="打印状态" align="center" width="120" key="16"
						v-if="chooseheadlist.includes('打印状态')">
						<template slot-scope="scope">
							<p v-if="scope.row.dayzt == '2'">已打印</p>
							<p v-else>未打印</p>
						</template>
					</el-table-column> -->
					<el-table-column prop="shifqd" label="是否清单" align="center" width="100" key="17"
						v-if="chooseheadlist.includes('是否清单')">
						<template slot-scope="scope">
							<p v-if="scope.row.hasList == '1'">是</p>
							<p v-else>否</p>
						</template>
					</el-table-column>
					<el-table-column prop="kaiplx" label="是否负数" align="center" width="100" key="18"
						v-if="chooseheadlist.includes('是否负数')">
						<template slot-scope="scope">
							<p v-if="scope.row.kaiplx == '1'">是</p>
							<p v-else>否</p>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="diszt" label="邮件递送状态" align="center" width="200" key="17"
						v-if="chooseheadlist.includes('邮件递送状态')">
						<template slot-scope="scope">
							<div class="Centerhorizontally">
								<img src="../../../assets/img/yts.png" width="31px" height="32px"
									v-if="scope.row.emailSendState === '1'" />
								<img src="../../../assets/img/yts.png" width="31px" height="32px"
									v-else-if="scope.row.cardSendState === '1'" />
								<span v-else>未推送</span>
							</div>
						</template>
					</el-table-column> -->
					<el-table-column prop="yuanfpdm" label="原发票代码" align="center" width="120" key="19"
						v-if="chooseheadlist.includes('原发票代码')"></el-table-column>
					<el-table-column prop="yuanfphm" label="原发票号码" align="center" width="120" key="20"
						v-if="chooseheadlist.includes('原发票号码')"></el-table-column>
					<el-table-column prop="zhidr" label="制单人" align="center" width="120" key="21"
						v-if="chooseheadlist.includes('制单人')"></el-table-column>
					<el-table-column prop="shenqr" label="申请人" align="center" width="120" key="22"
						v-if="chooseheadlist.includes('申请人')"></el-table-column>
                    <el-table-column prop="cank1" label="参考一" align="center" width="200" key="23"
                                    v-if="chooseheadlist.includes('参考一')"></el-table-column>
                    <el-table-column prop="cank2" label="参考二" align="center" width="200" key="24"
                           v-if="chooseheadlist.includes('参考二')"></el-table-column>
					<el-table-column prop="kaipzddm" label="税盘编号" align="center" width="200" key="25"
						v-if="chooseheadlist.includes('税盘编号')"></el-table-column>
				</el-table>
			</div>
			<div class="lastend">
				<div>
					当前已勾选
					<span>{{ selectCount }}</span>条
				</div>
				<div>
					汇总未税金额
					<span>￥{{ toThousands(Amountformat(jiastotalSum)) }}</span>
				</div>
				<div>
					汇总税额
					<span>￥{{ toThousands(Amountformat(taxtotalSum)) }}</span>
				</div>
				<div>
					汇总价税合计
					<span>￥{{ toThousands(Amountformat(totalSum)) }}</span>
				</div>
			</div>
			<div class="buttompage">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:page-sizes="[10, 20, 100, 500]" :page-size="pagenum" :key="elementui_page_component_key"
					:current-page="currentpage" layout="total, sizes, prev, pager, next, jumper" :total="totalcount">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import md5 from 'js-md5';
	export default {
		components: {},
		data() {
			return {
				isQuery: false,
				isshou: true,
				cxdialog: false,
				page: 1,
				pagenum: 10,
				totalcount: 10,
				tableData: [],
				headtitle: ['快递单上传'],
				currentpage: 1,
				elementui_page_component_key: '',
				selectRows: [],
				selectIds: [],
				selectCount: 0,
				jiastotalSum: 0,
				taxtotalSum: 0,
				allitem: {},
				allitemList: [],
				outerVisible: false,
				//价税合计
				totalSum: 0,
				searchalllist: {
					faplxdm: '',
					faply: '',
					fapdm: '',
					faphm: '',
					danjh: '',
					fapzt: '',
					goufmc: '',
                    goufsbh: '',
					hejje: '',
					hejse: '',
					kaiprq: '',
					dayzt: '',
					shifqd: '',
					qingddyzt: '',
					diszt: '',
					yuanfpdm: '',
					yuanfphm: '',
					zidysm: '',
					beiz: '',
					jiashj: '',
					xiaofmc: '',
                    xiaofsbh: '',
				},
				orderInfo: {},
				chooseheadlist: [],
				showsk: true,
                daorudiag: false,
				daorutitle: ['选择文件'],
				upfilename: "",
				filestate: "",
			};
		},
		created() {
			this.getInvoiceQueryList();
			this.chooseheadlist = ['单据号','单据状态','发票类型','发票代码','发票号码','购方名称','购方识别号','未税金额'
				,'税额','开票日期','打印状态','是否清单','是否负数','原发票代码','原发票号码'
                ,'快递单号','快递下单日期','快递公司','销方名称','销方识别号'];
		},
		mounted() {
			_this = this
			var obj = JSON.parse(localStorage.getItem('useropj'));
			if (!(obj.currCompany.organizationType == "0")) {
				this.showsk = false
			}
			this.repairtable();
		},
		methods: {
			sktbover() {
				this.getInvoiceQueryList();
			},
			sktbclose() {
			},
			sktbButton() {
			},
			choosetitle(e) {
				debugger
				this.chooseheadlist = e
				this.repairtable();
			},
			repairtable() {
				this.$nextTick(() => {
					setTimeout(() => {
						this.$refs.multipleTable.doLayout();
					}, 300);
					window.onresize = () => {
						setTimeout(() => {
							this.$refs.multipleTable.doLayout();
						}, 300);
					};
				});
			},
			sortChange(column) {
				var issuccess = false;
				//获取字段名称和排序类型
				var fieldName = column.prop;
				var sortingType = this.getHqlOrderType(column.order);
				this.orderInfo[fieldName] = sortingType;
				issuccess = true;
				if (issuccess) {
					this.getInvoiceQueryList(this.orderInfo);
				}
			},
			handleHeadAddClass({
				column
			}) {
				if (this.orderInfo[column.property]) {
					column.order = this.getVueOrderType(this.orderInfo[column.property]);
				}
			},
			closeouterVisible() {
				this.outerVisible = false;
			},
			changeshou() {
				this.isshou = !this.isshou
			},
			/* table选中发生改变 */
			handleSelectionChange(e) {
				this.selectRows = [];
				this.selectIds = [];
				this.selectCount = 0;
				this.jiastotalSum = 0;
				this.taxtotalSum = 0;
				this.totalSum =0;
				e.forEach((item, index) => {
					this.selectCount++;
					this.selectIds.push(item.id);
					this.selectRows.push(item);
					this.jiastotalSum = this.printFn(parseFloat(this.jiastotalSum) + parseFloat(item.hejje));
					this.taxtotalSum = this.printFn(parseFloat(this.taxtotalSum) + parseFloat(item.hejse));
						this.totalSum = this.printFn(parseFloat(this.totalSum) + parseFloat(item.jiashj));
				});
			},
			handleSizeChange(val) {
				this.pagenum = val;
				this.getInvoiceQueryList();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getInvoiceQueryList();
			},
			resetForm(formName) {
				Object.keys(this.searchalllist).map(key => (this.searchalllist[key] = ''));
			},
			forshuai() {
				this.isQuery = true;
				this.elementui_page_component_key++;
				this.currentpage = 1;
				this.page = 1
				this.orderInfo = {
					"kaiprq": "desc"
				}
				this.getInvoiceQueryList(this.orderInfo);
				this.cxdialog = false;
			},
			getInvoiceQueryList(orderInfo) {
				var newForm = JSON.parse(JSON.stringify(this.searchalllist));
				if (newForm && newForm.kaiprq) {
					newForm.kaiprq = newForm.kaiprq.join(',');
				}
				if (orderInfo == null) {
					orderInfo = {
						"kaiprq": "desc"
					}
				}
				newForm.orderInfo = JSON.stringify(orderInfo);
				let params = {
					page: this.page,
					limit: this.pagenum,
					search: newForm
				};
				this.title = '';
				this.allitem = {};
				this.outerVisible = false;
				this.$https.fetchPost('/cust/express/getExpressDocQueryList', params).then(res => {
					this.tableData = res.data.data;
					this.totalcount = res.data.count;
					// this.allitemList = res.data.allitem; // 预览用的数据
					this.replaceData();
				});
			},
            excelExport() {
                let type = 0;
                let urlTarget = 'cust/express/exportExpressDoc';
				let signParam = {
					userCode: localStorage.getItem('useropj') ? JSON.parse(localStorage.getItem('useropj'))[
						'userCode'] : 'null',
					token: localStorage.getItem('token'),
					timestamp: new Date().getTime(),
					url: urlTarget
				}
				var newForm = JSON.parse(JSON.stringify(this.searchalllist));
				if (newForm.kaiprq) {
					newForm.kaiprq = newForm.kaiprq.join(',');
				}
				newForm.ids = this.selectIds.toString();
				newForm.type = type;
				var date = new Date().getFullYear() + '' + (new Date().getMonth() + 1) + '' + new Date().getDate();
				let sign = md5(`${signParam.userCode}${signParam.token}${signParam.timestamp}${signParam.url}`);
				let url = this.$https.baseURL + 'cust/express/exportExpressDoc'; //请求下载文件的地址
				let fileName = '快递单信息导出' + date;
				this.$refs.download.download(url + `?sign=${sign}&timestamp=${signParam.timestamp}`, {
					fileType: 'xls',
					fileName: fileName,
					page: this.page,
					limit: this.pagenum,
					sort: 'desc',
					order: 'rd.kaiprq',
					search: newForm
				});
			},
            handleImport(type) {
				this.release();
				this.daorudiag = true;
			},
            release() {
				this.upfilename = ""
				this.filestate = null
				this.upfile = ""
				this.radionochoose = ""
			},
			uploadFile($event) {
				this.upfilename = $event.target.files[0].name
				var reader = new FileReader();
				let fileData = $event.target.files[0]
				let formData = new FormData();
				formData.append('uploadFile', fileData);
				this.upfile = formData

			},
            sureupload() {
				this.uploadExcel(this.upfile)
			},
			uploadExcel(upfile) {
				var url = "cust/express/uploadInvoiceExpressExcel";
				let params = upfile;
				this.$https.fetchPost(url, params).then(res => {
					if (res.data.success) {
						this.getInvoiceQueryList()
						this.daorudiag = false
					}

				})
			},
			getHqlOrderType(sortType) {
				switch (sortType) {
					case "ascending":
						return "desc";
						break;
					case "descending":
						return "asc";
						break;
				}
			},
			getVueOrderType(sortType) {
				switch (sortType) {
					case "desc":
						return "ascending";
						break;
					case "asc":
						return "descending";
						break;
				}
			},
			handleClick(index, title) {
				this.title = title;
				this.allitem = JSON.parse(JSON.stringify(this.allitemList[index]));
				this.outerVisible = true;
			},
			replaceData() {
				const arr1 = this.tableData;
				const arr2 = this.allitemList;
				const arrs = arr1.map(item => {
					const data = arr2.find(i => item.id == i.id)
					return {
						...item
					}
				});
				this.tableData = arrs;
			}
		}
	};
</script>

<style scoped="scoped" lang="less">
	.gedline {
		height: 16px;
		background-color: #f8f8f8;
	}

	/deep/.el-form-item__label {
		display: flex;
		justify-content: center;
		padding-left: 10px;
	}

	/deep/.el-date-editor--daterange.el-input,
	.el-date-editor--daterange.el-input__inner,
	.el-date-editor--timerange.el-input,
	.el-date-editor--timerange.el-input__inner {
		width: 100%
	}

	/deep/.el-select {
		width: 100%;
	}

	/deep/ .el-input--suffix .el-input__inner {
		padding-right: 15px;
	}

	.shousuo:extend(.Verticalcenter) {
		height: 16px;
		background-color: #f8f8f8;
	}

	.shousuo:hover {
		background: #f8f8f8;
	}

	.minheight {
		height: 50px;
		overflow: hidden;
		transition: all .3s ease;
	}

	.maxheight {
		height: 200px;
		transition: all .3s ease;
	}

	/deep/ .el-dialog__body {
		padding: 0;
	}

	/deep/ .el-table--small td {
		padding: 4px 0;
	}

	/deep/ .el-table__body-wrapper {
		min-height: 160px;
	}

	.topspan>span {
		font-size: 17px;
		color: #0080ff;
	}

	.areatable {
		margin-top: 27px;
	}

	.areacontent {
		margin-left: 21px;
	}

	.send_status_div /deep/.el-form-item__label {
		padding: 0px !important;
	}

   
	.sendinput {
		visibility: hidden;
	}

	.bt1 {
		width: 80px;
		height: 31px;
		border: 1px solid #e5e5e5;
		border-radius: 3px;
		font-size: 14px;
		cursor: pointer;
		font-weight: 500;
		color: #2f66fc;
	}

</style>
